"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var getInputTheme_1 = __importDefault(require("./getInputTheme"));
var DEFAULT_ELEMENT = 'input';
exports.Input = react_1.default.forwardRef(function AOInput(_a, ref) {
    var _b;
    var _c = _a.as, ElementType = _c === void 0 ? DEFAULT_ELEMENT : _c, className = _a.className, state = _a.state, disabled = _a.disabled, _d = _a.type, type = _d === void 0 ? 'text' : _d, _e = _a.seamless, seamless = _e === void 0 ? false : _e, _f = _a.fullWidth, fullWidth = _f === void 0 ? false : _f, props = __rest(_a, ["as", "className", "state", "disabled", "type", "seamless", "fullWidth"]);
    var _g = getInputTheme_1.default(state, disabled), border = _g.border, background = _g.background;
    return (react_1.default.createElement(ElementType, __assign({ className: classnames_1.default('p-3 text-body leading-snug rounded placeholder-gray focus:outline-none', (_b = {},
            _b['border border-solid focus:shadow-outline-blue'] = !seamless,
            _b['border-0 bg-transparent'] = seamless,
            _b['w-full'] = fullWidth,
            _b), !seamless && [border, background], className), disabled: disabled, "aria-invalid": state === 'error' || undefined, "data-aods": "input" }, props, { ref: ref, type: type })));
});
exports.default = exports.Input;
//# sourceMappingURL=Input.js.map